import Vue from 'vue'
import '@/plugins/element.js'
import '@/plugins/axios'
import App from './App.vue'
import router from './router'
import store from '@/store'
import Stackhub from '@kso/stackhub/vuex'
import Kdialog from '@/plugins/kdialog'
import '@/assets/css/common.scss'
import VueCompositionAPI from '@vue/composition-api'
import modules from '@/config/modules'
import DW from '@quick/dw-reporter'
import i18n from '@/i18n'
import { useKmon } from '@/plugins/kmon'

Vue.config.productionTip = false
Vue.prototype.$report = new DW({
  appKey: 'e8660369b684c2e5',
  autoUid: true
})


useKmon()


Vue.prototype.$stackhub = new Stackhub(store)
Vue.prototype.$modules = modules

Vue.use(Kdialog)
Vue.use(VueCompositionAPI)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
